var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756383667473,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 53895,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M736.8 165h-73.5v60h73.5c38.6 0 70 31.4 70 70v441.8c0 38.6-31.4 70-70 70H295c-38.6 0-70-31.4-70-70V295c0-38.6 31.4-70 70-70h64.3v-60H295c-71.7 0-130 58.3-130 130v441.8c0 71.7 58.3 130 130 130h441.8c71.7 0 130-58.3 130-130V295c0-71.7-58.3-130-130-130z",
    fill: "#6b7280",
    "p-id": 53896
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M543.5 284.9h-64.3c-49.5 0-89.9-40.3-89.9-89.9s40.3-89.9 89.9-89.9h64.3c49.5 0 89.9 40.3 89.9 89.9s-40.4 89.9-89.9 89.9z m-64.3-119.8c-16.5 0-29.9 13.4-29.9 29.9s13.4 29.9 29.9 29.9h64.3c16.5 0 29.9-13.4 29.9-29.9s-13.4-29.9-29.9-29.9h-64.3z",
    fill: "#6b7280",
    "p-id": 53897
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M449.1 413.8H320.3c-16.6 0-30-13.4-30-30s13.4-30 30-30h128.8c16.6 0 30 13.4 30 30s-13.4 30-30 30zM519 541.8H320.3c-16.6 0-30-13.4-30-30s13.4-30 30-30H519c16.6 0 30 13.4 30 30s-13.4 30-30 30zM658 670H320.3c-16.6 0-30-13.4-30-30s13.4-30 30-30H658c16.6 0 30 13.4 30 30s-13.4 30-30 30z",
    fill: "#6b7280",
    "p-id": 53898
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyReport);
export default __webpack_public_path__ + "static/media/my-report.2f68a4af.svg";
export { ForwardRef as ReactComponent };